// This function allow to reference chunks
__webpack_require__.k = (chunkId) => {
  // return url for filenames not based on template
  
  // return url for filenames based on template
  return "" + "__federation_expose_App" + "." + "967f24ce4dfaf317" + ".css"
}